import {
  Avatar,
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  TextField,
} from '@mui/material';
import Select from '@mui/material/Select';
import React, { SetStateAction, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { handleError } from '../../../../shared/functions/handleError';
import { IDepartment } from '../../../../shared/interfaces/department/IDepartment';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { AdminEmployeeService } from '../../employees/service';

interface IProps {
  department: IDepartment;
  setDepartment: React.Dispatch<SetStateAction<IDepartment | null>>;
  selectedUserIds: number[];
  setSelectedUserIds: React.Dispatch<SetStateAction<number[]>>;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const EmployeeFormModalBody = ({
  setSelectedUserIds,
  selectedUserIds,
  department,
  setDepartment,
}: IProps) => {
  const { t } = useTranslation();
  const [users, setUsers] = useState<IUser[]>([]);

  useEffect(() => {
    AdminEmployeeService.getAll({ page: 1, perPage: 0 })
      .then((response) => {
        setUsers(response?.data);
      })
      .catch((err) => handleError(err));
  }, []);
  return (
    <Box sx={{ marginTop: '30px', marginBottom: '30px', width: '100%' }}>
      <TextField
        value={department?.name}
        onChange={(e) => {
          setDepartment(
            (prev) => ({ ...prev, name: e?.target?.value }) as IDepartment,
          );
        }}
        label={t('general.departmentName')}
        sx={{ width: '100%' }}
      />
      <FormControl fullWidth sx={{ marginTop: '20px' }}>
        <InputLabel id="user-label">{t('general.users')}</InputLabel>
        <Select
          label={t('general.users')}
          labelId="user-label"
          fullWidth
          id="user-select"
          multiple
          value={selectedUserIds}
          input={<OutlinedInput label={t('general.users')} />}
          renderValue={() => {
            return users
              ?.filter((user) => selectedUserIds?.includes(user?.id))
              ?.map((user) => `${user?.firstName} ${user?.lastName}`)
              ?.join(', ');
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
              },
            },
          }}
          onChange={(event) => {
            setSelectedUserIds(event?.target?.value as number[]);
          }}
        >
          {users?.map((user) => {
            return (
              <MenuItem key={user?.id} value={user.id}>
                <Checkbox checked={selectedUserIds.includes(user.id)} />
                <Avatar
                  alt={`${user?.firstName} logo`}
                  sx={{
                    margin: '0 6px',
                    width: 28,
                    height: 28,
                  }}
                  src={user?.profilePhoto?.thumbnail}
                />
                {user?.firstName} {user?.lastName}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

export default EmployeeFormModalBody;
